//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import BlockAlert from '~/components/users/BlockAlert.vue';

export default {
  components: {
    BlockAlert,
  },

  computed: {
    ...mapState('user', ['user']),

    userLockList() {
      const { userLockList } = this.user;
      if (userLockList && userLockList.length) {
        return userLockList;
      }
      return [];
    },
  },
};
